import z from 'zod';

export const ExportableDeferredAmounts = z
  .object({
    principal: z.number(),
    interest: z.number(),
  })
  .meta({ title: 'DeferredAmounts' });
export type ExportableDeferredAmounts = z.infer<typeof ExportableDeferredAmounts>;
